import { get, isNil, omit } from 'lodash'
import { combineReducers } from 'redux'

import notifications from 'store/slices/notifications'
import popupReducer from '../reducers/popup'
import recaptcha from '../slices/recaptcha'
import remoteConfig from '../slices/remoteConfig'
import settings from '../slices/settings'
import timeline from '../slices/timeline'
import callChat from '../slices/callChat'
import agora from '../slices/agora'
import modalsV2 from '../slices/modals'
import postBox from '../slices/postBox'
import giftBox from 'store/slices/giftBox'
import conferenceCallReducer from './conferenceCall'
import uiStateReducer from './uiState'
import { CONFIRM_BOX } from 'features/GlobalConfirmBox/config'
import { LocalStorage } from 'lib/storage'
import { yayApi } from '../api/baseApi'
import { authReducer } from '../ducks/auth'

const confirmBoxes = (
  state = Object.keys(CONFIRM_BOX).reduce(
    (acc, key) => ({
      ...acc,
      [CONFIRM_BOX[key]]: { isActive: false, data: null },
    }),
    {}
  ),
  action: any
) => {
  switch (action.type) {
    case 'CONFIRMBOX_TOGGLE': {
      return {
        ...state,
        [action?.payload?.key]: {
          ...state[action?.payload?.key],
          isActive: !state[action?.payload?.key]?.isActive,
          ...(action?.payload || {}),
        },
      }
    }
    case 'CONFIRMBOX_TOGGLE/CLOSE': {
      return {
        ...state,
        [action?.payload?.key]: {
          ...state[action?.payload?.key],
          isActive: false,
        },
      }
    }
    default:
      return state
  }
}

const modals = (
  state = {
    postBox: { isActive: false },
    giftBox: { isActive: false },
  },
  action: any
) => {
  switch (action.type) {
    case 'MODAL_TOGGLE': {
      return {
        ...state,
        [`${get(action, 'params.key')}`]: {
          ...(get(action, 'params.retainPreviousState')
            ? omit(get(state, `${get(action, 'params.key')}`), 'isActive')
            : {}),
          isActive: !isNil(get(action, 'params.forcedTo'))
            ? get(action, 'params.forcedTo')
            : !get(state, `${get(action, 'params.key')}.isActive`, false),
          ...get(action, 'params'),
        },
      }
    }
    default:
      return state
  }
}

const chatSetting = (
  state = LocalStorage.chatSettings.get({}),
  action: any
) => {
  switch (action.type) {
    case 'CHAT_ETERNAL_IMAGE_MODE':
      const newState = {
        ...state,
        [action.payload.key]: {
          ...state[action.payload.key],
          isEternalImageMode: action.payload.isActive,
        },
      }
      LocalStorage.chatSettings.set(newState)

      return newState
    default:
      return state
  }
}

const reducers = combineReducers({
  uiState: uiStateReducer,
  auth: authReducer,
  notifications,
  timeline,
  settings,
  postBox,
  giftBox,
  confirmBoxes,
  modals,
  modalsV2,
  agora,
  callChat,
  chatSetting,
  popup: popupReducer,
  conferenceCall: conferenceCallReducer,
  [yayApi.reducerPath]: yayApi.reducer,
  remoteConfig,
  recaptcha,
})

export type AppState = ReturnType<typeof reducers>

export default reducers
